module.exports = __webpack_public_path__ + "img/custom_embroidery_pattern.85a46220.jpeg";